module.exports = __webpack_public_path__ + "img/partners.5ceec99a.png";